import { JIRA_PRIORITY_CODE, JiraPriority } from 'components/molecules/JiraBugReportModal';
import { getAuthUserMail } from 'utils/helperMethods';

export const prepareJiraRequestPayload = (
    summary: string,
    description: string,
    attachments: File[],
    priority: JiraPriority,
): FormData => {
    const userEmail = getAuthUserMail();
    const INSTANCE_URL = window?.location?.origin || '';

    const formData = new FormData();
    formData.append('summary', summary);
    formData.append('description', description);
    formData.append('reporter_id', userEmail);
    formData.append('source_url', INSTANCE_URL);
    formData.append('priority', String(JIRA_PRIORITY_CODE[priority]));

    for (const file of attachments) {
        formData.append('attachments', file);
    }

    return formData;
};
